<template>
  <section
    v-if="!userHasSubscription && !isBusinessUser"
    :class="['eda-premium__section', isEDAPremiumPage && 'eda-premium__section--eda-premium-page']"
  >
    <div class="eda-premium__content">
      <div class="eda-premium__text">
        <div class="eda-premium__text-title-enquiry">PRE-SALE SAVINGS FOR NEW SUBSCRIBERS</div>
        <div class="eda-premium__text-title">Buy now and save $200!</div>
        <div class="eda-premium__details">
          Pre-Sale available now for <strong>NEW SUBSCRIBERS!</strong> Purchase the eEDA exam
          voucher during pre-sale and receive three months of INE's Premium subscription to help you
          prepare! Don't wait - purchase during pre-sale and <strong>SAVE $200</strong> off regular
          pricing. You'll be one of the first eligible to take the eEDA exam when it becomes
          available on June 28, 2023!
        </div>
        <div class="eda-premium__cta">
          <router-link
            :to="{ name: 'eeda-presale' }"
            :class="[
              'btn btn--primary btn--responsive btn--full-mobile',
              isEDAPremiumPage && 'eda-premium__cta-button--hide',
            ]"
          >
            Claim this deal
          </router-link>
        </div>
      </div>
      <div class="eda-premium__badge">
        <img
          :src="eEDAPremiumBadge"
          alt="eEDA Premium Dynamic Exam"
          class="eda-premium__badge-icon"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import eEDABadgeIcon from '@/assets/icons/certs/eEDA_badge_white.png'

export default {
  name: 'EDAPremiumPreSaleSection',
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    isEDAPremiumPage() {
      return this.$route.name === 'eeda-presale'
    },
    eEDAPremiumBadge() {
      return eEDABadgeIcon
    },
  },
}
</script>

<style lang="scss">
.eda-premium {
  &__section {
    background-image: url('../../assets/images/backgrounds/confetti.png'),
      var(--blue-purple-gradient);
    background-repeat: no-repeat;
    background-position: top;
    background-size: 130%;
    position: relative;
    top: -60px;
    padding: 30px 20px 90px 20px;
    margin-bottom: -150px;
    @include mobile {
      padding: 90px 20px 90px 20px;
      background-position: center right;
      background-size: contain;
      margin-bottom: -130px;
    }
    @include desktop {
      background-position: center right;
      background-size: contain;
    }
    @include lg-desktop {
      background-position: center right 33%;
      background-size: contain;
      height: 37em;
    }
  }
  &__content {
    display: flex;
    flex-flow: column-reverse;
    padding: 50px 0;
    @include mobile {
      flex-flow: row;
      padding: 50px 20px;
    }
    @include desktop {
      max-width: 1120px;
      margin: auto;
      padding: 0 0 80px 0;
      align-items: center;
    }
  }
  &__badge {
    text-align: center;
    margin-bottom: 10px;
    &-icon {
      width: 215px;
      @include mobile {
        width: 260px;
      }
      @include desktop {
        width: 405px;
      }
    }
  }
  &__text {
    font-family: var(--font-medium);
    color: var(--white);
    &-title {
      font-weight: 700;
      font-size: rem(30px);
      line-height: 38px;
      padding: 10px 0;
      @include mobile {
        font-size: rem(40px);
        line-height: 52px;
      }
      @include desktop {
        font-size: rem(54px);
        line-height: 60px;
      }
      &-enquiry {
        color: var(--strong-light-green-b5);
        font-weight: 500;
        font-size: rem(14px);
        line-height: 20px;
        @include mobile {
          font-size: rem(16px);
          line-height: 23px;
        }
        @include desktop {
          font-weight: 700;
          font-size: rem(15px);
          line-height: 14px;
        }
      }
    }
  }
  &__details {
    font-family: var(--font-regular);
    font-weight: 450;
    font-size: (14px);
    line-height: 20px;
    margin-bottom: 10px;
    width: 95%;
    @include mobile {
      margin-bottom: 20px;
    }
    @include desktop {
      font-weight: 500;
      font-size: (18px);
      line-height: 24px;
      margin-bottom: 40px;
    }
  }
  &__cta-button {
    &--hide {
      display: none !important;
    }
  }
}
</style>
